import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React, { useContext } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import TabsContext from './context';
import Icon from '../icon';

var ArrowButton = function ArrowButton(props) {
  var _context, _classNames;

  var context = useContext(TabsContext);

  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls;

  var className = props.className,
      direction = props.direction,
      disabled = props.disabled,
      onClick = props.onClick;
  var arrowButtonPrefixCls = getPrefixCls(prefixCls, 'arrow-button');
  var arrowButtonClasses = classNames(arrowButtonPrefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(arrowButtonPrefixCls, "-dynamic"), (context === null || context === void 0 ? void 0 : context.type) === 'dynamic'), _defineProperty(_classNames, _concatInstanceProperty(_context = "".concat(arrowButtonPrefixCls, "-")).call(_context, direction), direction), _defineProperty(_classNames, "".concat(arrowButtonPrefixCls, "-line"), (context === null || context === void 0 ? void 0 : context.type) === 'line'), _defineProperty(_classNames, "".concat(arrowButtonPrefixCls, "-disabled"), disabled), _classNames));
  return /*#__PURE__*/React.createElement("span", {
    className: arrowButtonClasses,
    onClick: onClick
  }, direction === 'left' ? /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-left"
  }) : /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-right"
  }));
};

ArrowButton.displayName = 'ArrowButton';
export default ArrowButton;